import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter } from "react-router-dom";
import { ScrollToTopOnRouteChange } from "@/components/navigation/ScrollToTopOnRouteChange";
import { AuthProvider } from "./contexts/AuthContext";
import { TenantProvider } from "./contexts/TenantContext";
import { ToastProvider } from "./contexts/ToastContext";
import { TransferCartProvider } from "./contexts/TransferCartContext";
import AppRoutes from "./routes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter
        future={{
          v7_startTransition: true,
        }}
      >
        <TenantProvider>
          <AuthProvider>
            <ToastProvider>
              <TransferCartProvider>
                <ScrollToTopOnRouteChange />
                <AppRoutes />
              </TransferCartProvider>
            </ToastProvider>
          </AuthProvider>
        </TenantProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
